<script setup>
import CustomSelect from "../components/CustomSelect.vue";
import HauptMenue from "../components/HauptMenue.vue";
import FooterMenu from "../components/FooterMenu.vue";
import DatenschutzHinweis from "../components/DatenschutzHinweis.vue";
import MitarbeiterAccordion from "../components/MitarbeiterAccordion.vue";
import ButtonBack from "../components/ButtonBack.vue";
import { store } from "../components/store.vue";
import ServerTalk from "../plugins/serverTalk.vue";
/** Komponente zum Einbinden des Menüpunktes mit den Mitarbeiterstammdaten
 * @displayName Seite Mitarbeiterstammdaten
 */
</script>
<script>
export default {
  name: "Mitarbeiterstammdaten",
  components: {
    CustomSelect,
    HauptMenue,
    FooterMenu,
    DatenschutzHinweis,
  },
  data() {
    return {
      store,
      openIndex: 0, // Erstes Element sofort aufklappen
    };
  },
  methods: {
    formatDate(date) {
      if (
        typeof date === "undefined" ||
        (typeof date == "string" && date === "")
      ) {
        return "-";
      }
      const options = { day: "2-digit", month: "2-digit", year: "numeric" };
      const formattedDate = new Date(date).toLocaleDateString("de-DE", options);
      return formattedDate;
    },
    formatValue(value) {
      if (typeof value === "string") {
        // Falls der Wert mit einem Komma beginnt, eine "0" voranstellen
        if (value.startsWith(",")) {
          value = "0" + value;
        }
        // Falls Wert kein Komma enthält, Nachkommastellen ergänzen
        if (value.indexOf(",") < 0) {
          value += ",00";
        }
        // Prüfen, ob nach dem Komma nur eine Stelle steht
        else if (/,\d$/.test(value)) {
          value += "0"; // Eine Null anhängen, wenn nur eine Dezimalstelle vorhanden ist
        }
        // Ggf. Dezimalpunkt ergänzen
        if (value.indexOf(".") < 0 && value.length > 6) {
          let lengthP1 = value.length - 6;
          value =
            value.substring(0, lengthP1) + "." + value.substring(lengthP1);
        }
      }
      return value;
      const openIndex = ref(null);

      function toggleAccordion(index) {
        openIndex.value = openIndex.value === index ? null : index;
      }
    },
    getVersicherungen: function (versicherungen) {
      //gibt die Versicherungen immer als Array zurück
      let vers = [];
      //let versicherungen =
      //  store.xSelectedMitarbeiter?.Versicherungen?.VERSNR;
      versicherungen?.VERSNR;
      //es ist ein Array. Alles ok.
      if (Array.isArray(versicherungen)) {
        vers = versicherungen.map((v) => v);
      } else if (typeof versicherungen === "object") {
        //console.log("versicherungen", versicherungen);
        if (versicherungen !== "") {
          vers.push(versicherungen);
        }
      }

      return vers;
    },
    getSTNR: function (pmnr) {
      let stnr = pmnr?.STNR;
      return stnr ? stnr : "";
    },
    toggle(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
  },
  beforeCreate: function () {
    this.$servertalk.doLog("# Reading From Local, Create ");
    if (!store.auth) {
      //if (!this.$servertalk.restoreStore())
      this.$router.push("/");
    }
    this.$servertalk.doLog("Inhalt store:");
    this.$servertalk.doLog(store);
  },
  mounted: function () {
    window.scrollTo(0, 0);
    this.$servertalk.doLog("# Reading From Local, Mount");
    if (!store.auth) {
      if (!this.$servertalk.restoreStore()) this.$router.push("/");
    }
    window._paq.push(["setDocumentTitle", this.name]);
    window._paq.push(["trackPageView"]);
    // Ermitteln des Index des aktuellen Mitarbeiters in subData
  },
  computed: {
    getPMNRs: function () {
      //gibt die PMNRs immer als Array zurück
      let pmnrArr = [];
      let PMNRs = store.xSelectedMitarbeiter?.Versorgungen?.PMNR;
      //es ist ein Array. Alles ok.
      if (Array.isArray(PMNRs)) {
        pmnrArr = PMNRs.map((v) => v);
      } else if (typeof PMNRs === "object") {
        pmnrArr.push(PMNRs);
      }

      return pmnrArr;
    },
  },
};
</script>
<template>
  <div class="main-wrapper schwebend" :class="store.accessRestriction">
    <HauptMenue />
    <div class="mt-36 md:mt-48 lg:mt-56 mb-8 max-w-7xl mx-auto px-5 lg:px-0">
      <div class="max-w-6xl mx-auto">
        <h1
          class="text-tertiary font-bold text-l md:text-xl lg:text-2xl text-center uppercase">
          Firma
          <span>
            "{{ store.subData.data.Firmenstammdaten.FNAME }}
            {{
              $servertalk.getName(
                "GESFORM",
                store.subData.data.Firmenstammdaten?.FGESFORM
              )
            }}
            {{ store.subData.data.Firmenstammdaten.FKENNR }}/{{
              store.subData.data.Firmenstammdaten.FABRGR
            }}"
          </span>
        </h1>
        <h2
          class="text-primary/75 font-bold text-2xl md:text-3xl lg:text-4xl text-center mb-12">
          {{ store.xSelectedMitarbeiter.VORNAME }}
          {{ store.xSelectedMitarbeiter.NAME }}
        </h2>

        <div
          class="grid grid-cols-1 sm:grid-cols-3 gap-4 bg-gray-50 rounded-lg p-8 mb-8">
          <div>
            <span class="text-xs uppercase text-gray-500">Anrede</span>
            <p class="text-lg font-medium">
              {{
                $servertalk.getName(
                  "ADRANREDE",
                  store.xSelectedMitarbeiter.GESCHL
                )
              }}
            </p>
          </div>
          <div>
            <span class="text-xs uppercase text-gray-500">Vorname</span>
            <p class="text-lg font-medium">
              {{ store.xSelectedMitarbeiter.VORNAME }}
            </p>
          </div>

          <div>
            <span class="text-xs uppercase text-gray-500">Nachname</span>
            <p class="text-lg font-medium">
              {{ store.xSelectedMitarbeiter.NAME }}
            </p>
          </div>
          <div>
            <span class="text-xs uppercase text-gray-500">Geburtstag</span>
            <p class="text-lg font-medium">
              {{ formatDate(store.xSelectedMitarbeiter.GEBDAT) }}
            </p>
          </div>
        </div>

        <!-- pmnr -->

        <div v-if="getPMNRs.length > 0">
          <MitarbeiterAccordion
            v-for="(myPMNR, index) in getPMNRs"
            :key="index"
            :isOpen="openIndex === index"
            @toggle="toggle(index)">
            <!-- Titel-Slot -->
            <template #versorgungtitle>
              <div>
                <span class="text-primary pr-2">PM-Nr. {{ myPMNR.PMNR }}</span>
                {{ myPMNR.PSTATUSN_TXT }} {{ getSTNR(myPMNR) }}
              </div>
            </template>

            <!-- Content-Slot -->
            <template #versorgungcontent>
              <div class="p-8 rounded-b-lg bg-gray-50">
                <!--<h2 class="text-lg text-primary uppercase">Versorgung</h2>

                <div
                  class="grid grid-cols-1 sm:grid-cols-4 sm:gap-4 justify-center items-end">
                  <div>
                    <div class="text-gray-500">PMNR</div>
                    <div class="mb-2 sm:mb-0">{{ myPMNR.PMNR }}</div>
                  </div>
                  <div>
                    <div class="text-gray-500">Personenstatus</div>
                    <div class="mb-2 sm:mb-0">{{ myPMNR.PSTATUSN_TXT }}</div>
                  </div>
                  <div>
                    <span class="text-gray-500">Stammnummer</span>
                    <p class="text-lg font-medium">{{ getSTNR(myPMNR) }}</p>
                  </div>
                  <div>
                    <span class="text-gray-500">Zusage</span>
                    <p class="text-lg font-medium">-</p>
                  </div>
                </div>-->

                <!-- Versicherungen -->

                <div v-if="getVersicherungen(myPMNR.Versicherungen).length > 0">
                  <h2 class="text-xl font-bold text-primary uppercase mb-4">
                    Versicherungen
                  </h2>
                  <div
                    v-for="(versicherung, vIndex) in getVersicherungen(
                      myPMNR.Versicherungen.VERSNR
                    )"
                    :key="vIndex"
                    class="relative border-b last:border-0 first-of-type:pt-0 py-8">
                    <span class="text-xs uppercase text-gray-500">
                      Versicherer:
                    </span>
                    <h2
                      class="text-xl text-tertiary font-bold mb-8 leading-none">
                      {{ $servertalk.getName("VUNR", versicherung.VUNR) }}
                    </h2>
                    <div
                      class="grid grid-cols-1 sm:grid-cols-4 sm:gap-4 justify-center items-end">
                      <div class="text-gray-500">Versicherungsnummer:</div>
                      <div class="mb-2 sm:mb-0">{{ versicherung.VERSNR }}</div>

                      <div class="text-gray-500">Status der Versicherung:</div>
                      <div class="mb-2 sm:mb-0">
                        {{
                          $servertalk.getName(
                            "VSTATUS",
                            versicherung.STVS,
                            true
                          )
                        }}
                      </div>

                      <div class="text-gray-500">Versicherungsbeginn:</div>
                      <div class="mb-2 sm:mb-0">
                        {{ formatDate(versicherung.VERSBEG) }}
                      </div>

                      <div class="text-gray-500">Ablaufdatum:</div>
                      <div class="mb-2 sm:mb-0">
                        {{ formatDate(versicherung.BZENDE) }}
                      </div>
                      <template v-if="!['0', ''].includes(versicherung.ALST)">
                        <div
                          v-if="
                            $servertalk.getName(
                              'ZAHLWEISE',
                              versicherung.ZWLSTG
                            ) == 'monatl + Sondzlg'
                          "
                          class="text-gray-500">
                          Monatl. garantierte Altersleistung + Sonderzahlung:
                        </div>
                        <div v-else class="text-gray-500">
                          <span class="capitalize">
                            {{
                              $servertalk.getName(
                                "ZAHLWEISE",
                                versicherung.ZWLSTG
                              )
                            }}e
                          </span>
                          garantierte Altersleistung:
                        </div>
                        <div class="mb-2 sm:mb-0">
                          {{ formatValue(versicherung.ALST) }} €
                        </div>
                        <div class="text-gray-500">Überschussanteile:</div>
                        <div class="mb-2 sm:mb-0">
                          {{ formatValue(versicherung.ALSTUEA) }} €
                        </div>
                      </template>
                      <template v-if="!['0', ''].includes(versicherung.TLST)">
                        <div
                          v-if="
                            $servertalk.getName(
                              'ZAHLWEISE',
                              versicherung.ZWLSTGHIZ
                            ) == 'monatl + Sondzlg'
                          "
                          class="text-gray-500">
                          Monatl. Todesfalleistung + Sonderzahlung:
                        </div>
                        <div v-else class="text-gray-500">
                          <span class="capitalize">
                            {{
                              $servertalk.getName(
                                "ZAHLWEISE",
                                versicherung.ZWLSTGHIZ
                              )
                            }}e
                          </span>
                          Todesfalleistung:
                        </div>
                        <div class="mb-2 sm:mb-0">
                          {{ formatValue(versicherung.TLST) }} €
                        </div>

                        <div class="text-gray-500">Überschussanteile:</div>
                        <div class="mb-2 sm:mb-0">
                          {{ formatValue(versicherung.TLSTUEA) }} €
                        </div>
                      </template>

                      <template v-if="!['0', ''].includes(versicherung.BULST)">
                        <div
                          v-if="
                            $servertalk.getName(
                              'ZAHLWEISE',
                              versicherung.ZWLSTGBUZ
                            ) == 'monatl + Sondzlg'
                          "
                          class="text-gray-500">
                          Monatl. BU-Leistung + Sonderzahlung:
                        </div>
                        <div v-else class="text-gray-500">
                          <span class="capitalize">
                            {{
                              $servertalk.getName(
                                "ZAHLWEISE",
                                versicherung.ZWLSTGBUZ
                              )
                            }}e
                          </span>
                          "BU-Leistung":
                        </div>
                        <div class="mb-2 sm:mb-0">
                          {{ formatValue(versicherung.BULST) }} €
                        </div>
                        <div class="text-gray-500">Überschussanteile:</div>
                        <div class="mb-2 sm:mb-0">
                          {{ formatValue(versicherung.BULSTUEA) }} €
                        </div>
                      </template>

                      <div
                        v-if="
                          $servertalk.getName(
                            'ZAHLWEISE',
                            versicherung.ZAHLWEISE
                          ) == 'monatl + Sondzlg'
                        "
                        class="text-gray-500">
                        Monatl. Beitrag + Sonderzahlung:
                      </div>
                      <div v-else class="text-gray-500 capitalize">
                        {{
                          $servertalk.getName(
                            "ZAHLWEISE",
                            versicherung.ZAHLWEISE
                          )
                        }}er Beitrag:
                      </div>
                      <div class="mb-2 sm:mb-0">
                        {{ formatValue(versicherung.BEITRAG) }} €
                      </div>

                      <div class="text-gray-500">Stand:</div>
                      <div class="mb-2 sm:mb-0">
                        {{ formatDate(versicherung.DATAB) }}
                      </div>

                      <template v-if="versicherung.AGANTPROZ">
                        <div class="text-gray-500">Arbeitgeberanteil:</div>
                        <div class="mb-2 sm:mb-0">
                          {{ versicherung.AGANTPROZ }} %
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </MitarbeiterAccordion>
        </div>
        <!-- /pmnr -->

        <div class="mt-6 text-center">
          <ButtonBack />
        </div>
      </div>
    </div>
  </div>

  <FooterMenu />
</template>
